import { render, staticRenderFns } from "./BatchInstitutionAccess.vue?vue&type=template&id=7346f139"
import script from "./BatchInstitutionAccess.vue?vue&type=script&lang=js"
export * from "./BatchInstitutionAccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports